import { html } from 'lit-html';

export const completedPageIcon = html`
<svg xmlns="http://www.w3.org/2000/svg" width="22.864" height="16" viewBox="0 0 22.864 16">
  <path d="M10.5,31.639h-.009a1.74,1.74,0,0,1-1.3-.609L1.249,21.766a1.721,1.721,0,0,1,.188-2.423,1.766,1.766,0,0,1,2.421.189l6.685,7.8L20.716,16.181a1.763,1.763,0,0,1,2.428-.109A1.693,1.693,0,0,1,23.7,17.26a1.712,1.712,0,0,1-.447,1.237L11.77,31.079a1.706,1.706,0,0,1-1.267.56Z" transform="translate(-0.837 -15.639)" fill="#1a1a1a"/>
</svg>
`;

export const currentPageIcon = html`
    <svg xmlns="http://www.w3.org/2000/svg" width="31.999" height="31.96" viewBox="0 0 31.999 31.96">
    <g data-name="in progress" transform="translate(-10 -10)">
        <path id="Path_2289" data-name="Path 2289" d="M47.839,10A1.435,1.435,0,0,0,46.4,11.441V16.4a1.441,1.441,0,1,0,2.881,0V11.441A1.435,1.435,0,0,0,47.839,10Z" transform="translate(-21.839)" fill="#1a1a1a"/>
        <path id="Path_2290" data-name="Path 2290" d="M23.149,21.07a1.471,1.471,0,1,0-2.08,2.08l3.52,3.52a1.471,1.471,0,0,0,2.08-2.08Z" transform="translate(-6.39 -6.39)" fill="#1a1a1a"/>
        <path id="Path_2291" data-name="Path 2291" d="M17.879,47.839A1.435,1.435,0,0,0,16.439,46.4h-5a1.441,1.441,0,0,0,0,2.881H16.4a1.469,1.469,0,0,0,1.48-1.441Z" transform="translate(0 -21.839)" fill="#1a1a1a"/>
        <path id="Path_2292" data-name="Path 2292" d="M24.59,63.769l-3.52,3.52a1.471,1.471,0,0,0,2.08,2.08l3.52-3.52a1.471,1.471,0,1,0-2.08-2.08Z" transform="translate(-6.39 -32.01)" fill="#1a1a1a"/>
        <path id="Path_2293" data-name="Path 2293" d="M47.839,70.3A1.435,1.435,0,0,0,46.4,71.741V76.7a1.441,1.441,0,0,0,2.881,0V71.78a1.469,1.469,0,0,0-1.441-1.48Z" transform="translate(-21.839 -36.181)" fill="#1a1a1a"/>
        <path id="Path_2294" data-name="Path 2294" d="M65.751,63.769a1.471,1.471,0,1,0-2.08,2.08l3.52,3.52a1.471,1.471,0,0,0,2.08-2.08Z" transform="translate(-31.952 -32.01)" fill="#1a1a1a"/>
        <path id="Path_2295" data-name="Path 2295" d="M76.8,46.4H71.839a1.441,1.441,0,0,0,0,2.881H76.8a1.441,1.441,0,1,0,0-2.881Z" transform="translate(-36.24 -21.839)" fill="#1a1a1a"/>
    </g>
    </svg>
`;

export const editIcon = html`
<svg xmlns="http://www.w3.org/2000/svg" width="17.999" height="18" viewBox="0 0 17.999 18">
  <path d="M25.007,17.211l-8.923,8.925a3.733,3.733,0,0,1-1.735.983l-3.422.855a.748.748,0,0,1-.907-.907l.855-3.422a3.717,3.717,0,0,1,.983-1.735l8.923-8.924,4.225,4.225Zm2.114-6.337a2.986,2.986,0,0,1,0,4.225l-1.057,1.055-4.225-4.225L22.9,10.873a2.986,2.986,0,0,1,4.225,0Z" transform="translate(-9.999 -9.997)" fill="#472961"/>
</svg>
`;

export const dots = html`
<span aria-hidden="true">
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 293.4 23.5" style="enable-background:new 0 0 293.4 23.5;" xml:space="preserve">
  <circle cx="11.5" cy="12" r="11.5"/>
  <circle cx="41.5" cy="12" r="11.5"/>
  <circle cx="71.6" cy="12" r="11.5"/>
  <circle cx="101.6" cy="12" r="11.5"/>
  <circle cx="131.7" cy="12" r="11.5"/>
  <circle cx="161.7" cy="12" r="11.5"/>
  <circle cx="191.8" cy="12" r="11.5"/>
  <circle cx="221.9" cy="12" r="11.5"/>
  <circle cx="251.9" cy="12" r="11.5"/>
  <circle cx="282" cy="12" r="11.5"/>
  </svg>
</span>
`

export const eyeSvg = html`
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve">
<path d="M10.6,232.5c172.8,155.2,300.9,155.2,476.5,0C309.5,68.1,182.1,68.1,10.6,232.5z M248.9,333.8
	c-56.2,0-101.7-45.5-101.7-101.7c0-56.2,45.5-101.7,101.7-101.7c56.2,0,101.7,45.5,101.7,101.7C350.6,288.3,305.1,333.8,248.9,333.8
	z"/>
<path d="M325.5,232.1c0,42.3-34.3,76.5-76.5,76.5c-42.3,0-76.5-34.3-76.5-76.5c0-12.1,2.8-23.6,7.9-33.8
	c4.8,9.7,14.9,16.4,26.5,16.4c16.3,0,29.6-13.2,29.6-29.6c0-10.5-5.4-19.7-13.6-24.9c8.2-3,17.1-4.6,26.3-4.6
	C291.2,155.6,325.5,189.9,325.5,232.1z"/>
</svg>
`;

export const eyeClosedSvg = html`
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve">
<path d="M309.5,313.9c-0.1,0.1-0.2,0.2-0.3,0.2l20.1,20.1c0.1,0,0.3-0.1,0.4-0.1L309.5,313.9z M134.2,139.1l32.8,32.8
	c0.1-0.1,0.1-0.2,0.2-0.3l-32.6-32.6C134.4,139,134.3,139.1,134.2,139.1z"/>
<path d="M290.1,344.9c-90.2,17.1-177-20.4-279.5-112.4c32-30.7,62.5-55.7,92.1-75l48,48c-2.3,8.5-3.5,17.4-3.5,26.6
	c0,56.2,45.5,101.7,101.7,101.7c9.2,0,18.1-1.2,26.6-3.5L290.1,344.9z"/>
<path d="M253.8,308.5c-1.6,0.1-3.2,0.2-4.8,0.2c-42.3,0-76.5-34.3-76.5-76.5c0-1.6,0-3.2,0.2-4.8L253.8,308.5z"/>
<path d="M291.4,295.8c-0.1,0.1-0.2,0.1-0.3,0.2l-81.4-81.5c0.2,0,0.3,0,0.5,0L291.4,295.8z"/>
<path d="M378.8,311.5c34.5-19,70.3-45.4,108.3-79C374.4,128.2,281.8,90.1,185.5,118.2L72.1,4.8L36.3,40.7l98.3,98.3l32.6,32.6
	l42.9,42.9l81.3,81.3l18,18l150,150l-0.3,0.3l0.2,0.2l36.1-36.1L378.8,311.5z M206.8,139.5c12.8-5.8,27.1-9.1,42.1-9.1
	c56.2,0,101.7,45.5,101.7,101.7c0,15-3.2,29.3-9.1,42.1l-19.5-19.5c2.2-7.2,3.4-14.8,3.4-22.6c0-42.3-34.3-76.5-76.5-76.5
	c-7.9,0-15.5,1.2-22.6,3.4L206.8,139.5z"/>
</svg>`;

export const arrow = html`
<svg xmlns="http://www.w3.org/2000/svg" width="21.221" height="16" viewBox="0 0 21.221 16">
  <path d="M23.318,21.273l-6.8-6.8a1.182,1.182,0,1,0-1.672,1.672l4.792,4.792H3.681a1.182,1.182,0,0,0,0,2.363H19.618l-4.771,4.792a1.17,1.17,0,0,0,0,1.672,1.218,1.218,0,0,0,.847.357,1.165,1.165,0,0,0,.847-.357l6.821-6.821a1.218,1.218,0,0,0,.357-.847,1.522,1.522,0,0,0-.4-.825Z" transform="translate(-2.499 -14.123)" fill="#472961"/>
</svg>
`
export const arrowBack = html`
<svg xmlns="http://www.w3.org/2000/svg" width="21.221" height="16" viewBox="0 0 21.221 16">
  <g transform="rotate(180 10.6 8)">
    <path d="M23.318,21.273l-6.8-6.8a1.182,1.182,0,1,0-1.672,1.672l4.792,4.792H3.681a1.182,1.182,0,0,0,0,2.363H19.618l-4.771,4.792a1.17,1.17,0,0,0,0,1.672,1.218,1.218,0,0,0,.847.357,1.165,1.165,0,0,0,.847-.357l6.821-6.821a1.218,1.218,0,0,0,.357-.847,1.522,1.522,0,0,0-.4-.825Z" transform="translate(-2.499 -14.123)" fill="#472961" />
  </g>
</svg>
`;


export const deleteIcon = html`
<svg xmlns="http://www.w3.org/2000/svg" width="19.002" height="19" viewBox="0 0 19.002 19">
  <g id="remove" transform="translate(0 0.003)">
    <path id="Path_2999" data-name="Path 2999" d="M9.5,19a9.5,9.5,0,1,1,7.194-3.288A9.5,9.5,0,0,1,9.5,19ZM9.506,1.862a7.633,7.633,0,1,0,4.988,1.857A7.633,7.633,0,0,0,9.506,1.862Z" transform="translate(0)" fill="#472961"/>
    <path id="Path_3000" data-name="Path 3000" d="M37.6,39.765l-5.646-4.878,1.217-1.411,5.647,4.876Z" transform="translate(-25.888 -27.121)" fill="#472961"/>
    <path id="Path_3001" data-name="Path 3001" d="M38.352,31.961l1.411,1.218-4.876,5.648-1.411-1.218Z" transform="translate(-27.118 -25.893)" fill="#472961"/>
  </g>
</svg>
`;

export const binIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="17.097" height="20" viewBox="0 0 17.097 20">
  <path id="bin" d="M40.113,21.274a.484.484,0,1,1,0,.968h-.334a.167.167,0,0,0-.168.164l-.58,15.336A1.837,1.837,0,0,1,37.21,39.5H26.887a1.836,1.836,0,0,1-1.822-1.758l-.58-15.336a.17.17,0,0,0-.168-.164h-.334a.484.484,0,1,1,0-.968h4.288a.254.254,0,0,0,.219-.152l.227-.568A1.77,1.77,0,0,1,30.274,19.5h3.548a1.766,1.766,0,0,1,1.556,1.053l.227.568a.254.254,0,0,0,.219.152Zm-8.387,4.194V36.436a.484.484,0,1,0,.968,0V25.468a.484.484,0,1,0-.968,0Zm-3.71.014.323,10.968a.484.484,0,0,0,.968-.028l-.323-10.968a.484.484,0,1,0-.968.028Zm7.1-.028L34.79,36.422a.484.484,0,0,0,.968.028l.323-10.968a.484.484,0,1,0-.968-.028Zm-5.5-4.54-.145.36h4.991a.1.1,0,0,0,.1-.146l-.086-.214a.8.8,0,0,0-.657-.446H30.274a.808.808,0,0,0-.657.446Z" transform="translate(-23.5 -19.5)" fill="#472961"/>
</svg>
`;

export const dashIcon = html`
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 23 16" style="enable-background:new 0 0 23 16;" xml:space="preserve">
  <path d="M19.8,8.9H3.3c-0.9,0-1.6-0.7-1.6-1.6v0c0-0.9,0.7-1.6,1.6-1.6h16.4c0.9,0,1.6,0.7,1.6,1.6v0C21.3,8.2,20.6,8.9,19.8,8.9z"/>
</svg>
`;

export const accountIcon = html`
<svg xmlns="http://www.w3.org/2000/svg" width="19.274" height="22" viewBox="0 0 19.274 22">
  <path id="user" d="M19.273,19.246a8.261,8.261,0,0,0-8.258-8.261H10.2a5.508,5.508,0,1,0-1.131,0h-.81A8.261,8.261,0,0,0,0,19.246,2.754,2.754,0,0,0,2.754,22H16.521a2.753,2.753,0,0,0,2.752-2.754Z" fill="#472961"/>
</svg>
`
export const organisationIcon = html`
<svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22">
  <path id="organisation" d="M29.741,21.005h2.807a.258.258,0,0,1,.241.271v2.836a.258.258,0,0,1-.241.271H12.031a.258.258,0,0,1-.241-.271V21.276a.258.258,0,0,1,.241-.271H15.1a2.325,2.325,0,0,0,.946-.243L22.1,17.469a.8.8,0,0,1,.627,0l6.062,3.294a2.319,2.319,0,0,0,.947.243ZM11.789,25.123v14.01a.258.258,0,0,0,.241.271H19.3a.258.258,0,0,0,.241-.271v-5.4a.7.7,0,0,1,.659-.74h4.177a.7.7,0,0,1,.658.74v5.4a.258.258,0,0,0,.241.271h7.27a.258.258,0,0,0,.241-.271V25.123a.258.258,0,0,0-.241-.271H12.03a.258.258,0,0,0-.241.271Z" transform="translate(-11.789 -17.405)" fill="#472961"/>
</svg>
`
export const lookupIcon = html`
<svg xmlns="http://www.w3.org/2000/svg" id="lookup" width="22" height="22.001" viewBox="0 0 22 22.001">
  <path id="Path_3004" data-name="Path 3004" d="M21.4,18.479,18.72,15.8A11.086,11.086,0,0,1,15.8,18.72L18.479,21.4A2.063,2.063,0,0,0,21.4,18.479" fill="#472961"/>
  <path id="Path_3005" data-name="Path 3005" d="M19.25,9.625a9.625,9.625,0,1,0-9.625,9.626A9.625,9.625,0,0,0,19.25,9.625M9.625,17.188a7.562,7.562,0,1,1,7.563-7.563,7.572,7.572,0,0,1-7.563,7.563" fill="#472961"/>
  <path id="Path_3006" data-name="Path 3006" d="M13.473,12.355a3.3,3.3,0,0,0-3.3-3.3H9.851a2.2,2.2,0,1,0-.451,0H9.076a3.3,3.3,0,0,0-3.3,3.3,1.1,1.1,0,0,0,1.1,1.1h5.5A1.1,1.1,0,0,0,13.473,12.355Z" fill="#472961"/>
</svg>
`;
export const switchIcon = html`
<svg xmlns="http://www.w3.org/2000/svg" width="21" height="14.7" viewBox="0 0 21 14.7">
  <g id="switch" transform="translate(-0.002 -76.8)">
    <path id="Path_3002" data-name="Path 3002" d="M103.45,83.1h14.7a1.05,1.05,0,0,0,.742-1.792l-4.2-4.2a1.05,1.05,0,0,0-1.485,1.485L115.615,81H103.45a1.05,1.05,0,1,0,0,2.1Z" transform="translate(-98.198)" fill="#472961"/>
    <path id="Path_3003" data-name="Path 3003" d="M15.752,281.6H1.052a1.05,1.05,0,0,0-.742,1.792l4.2,4.2a1.05,1.05,0,0,0,1.485-1.485L3.587,283.7H15.752a1.05,1.05,0,0,0,0-2.1Z" transform="translate(0 -196.4)" fill="#472961"/>
  </g>
</svg>
`;
export const addIcon = html`
<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
  <g id="add" transform="translate(-10 -10)">
    <path id="Path_2440" data-name="Path 2440" d="M30.04,37.27h2.941V32.98h4.29V30.039h-4.29v-4.29H30.04v4.29H25.75V32.98h4.29Z" transform="translate(-12.009 -12.008)" fill="#472961"/>
    <path id="Path_2441" data-name="Path 2441" d="M28.269,10H10.734a.734.734,0,0,0-.734.734V28.266a.733.733,0,0,0,.734.734H28.266A.733.733,0,0,0,29,28.266V10.734A.73.73,0,0,0,28.269,10Zm-.737,17.532H11.471V11.471H27.535V27.532Z" fill="#472961"/>
  </g>
</svg>
`

export const clock = html`
<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
  <g id="opening_times" data-name="opening times" transform="translate(-19 -19.062)">
    <path id="Path_2442" data-name="Path 2442" d="M45,33v5.21a1.533,1.533,0,0,0,1.532,1.532h4.29V37.9H46.839V33Z" transform="translate(-18.032 -9.667)" fill="#472961"/>
    <path id="Path_2443" data-name="Path 2443" d="M36.162,22.944A9.5,9.5,0,1,0,38,28.543a5.792,5.792,0,0,0-.022-.613H36.14c.016.2.028.407.028.613a7.662,7.662,0,1,1-1.318-4.291H31.872v1.839h5.21A.92.92,0,0,0,38,25.171v-5.21H36.162Z" fill="#472961"/>
  </g>
</svg>
`;

export const speechBubble = html`
<svg xmlns="http://www.w3.org/2000/svg" width="18.931" height="18" viewBox="0 0 18.931 18">
  <path id="tooltip" d="M19.48,4.8H4.431A1.933,1.933,0,0,0,2.5,6.732V16.944a1.933,1.933,0,0,0,1.931,1.931H8.511L11.159,22.4a.988.988,0,0,0,1.593,0l2.667-3.544H19.5a1.933,1.933,0,0,0,1.931-1.931V6.732A1.95,1.95,0,0,0,19.48,4.8Z" transform="translate(-2.5 -4.801)" fill="#472961"/>
</svg>

`;

export const close = html`
<svg id="close" xmlns="http://www.w3.org/2000/svg" width="14.679" height="14.679" viewBox="0 0 14.679 14.679">
  <path id="Path_304" data-name="Path 304" d="M28.487,26.426,26.652,28.26,39.5,41.105l1.834-1.834Z" transform="translate(-26.652 -26.426)" fill="#fff" fill-rule="evenodd"/>
  <path id="Path_305" data-name="Path 305" d="M39.5,26.426,26.652,39.271l1.834,1.834L41.331,28.26Z" transform="translate(-26.652 -26.426)" fill="#fff" fill-rule="evenodd"/>
</svg>
`;


export const closeAlt = html`
<svg id="close" xmlns="http://www.w3.org/2000/svg" width="14.679" height="14.679" viewBox="0 0 14.679 14.679">
  <path id="Path_304" data-name="Path 304" d="M28.487,26.426,26.652,28.26,39.5,41.105l1.834-1.834Z" transform="translate(-26.652 -26.426)" fill="#472961" fill-rule="evenodd"/>
  <path id="Path_305" data-name="Path 305" d="M39.5,26.426,26.652,39.271l1.834,1.834L41.331,28.26Z" transform="translate(-26.652 -26.426)" fill="#472961" fill-rule="evenodd"/>
</svg>
`;

export const downArrow = `
<svg xmlns="http://www.w3.org/2000/svg" width="13.783" height="8" viewBox="0 0 13.783 8">
  <path id="down_arrow" data-name="down arrow" d="M32.843,44.579a1.076,1.076,0,0,0,1.529,0L40.2,38.747a1.082,1.082,0,0,0-1.53-1.53l-5.067,5.036-5.036-5.036a1.036,1.036,0,0,0-.764-.319.988.988,0,0,0-.765.319,1.1,1.1,0,0,0,0,1.53Z" transform="translate(-26.732 -36.898)"/>
</svg>
`;

export const web = html`
<span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="32.001" height="32" viewBox="0 0 32.001 32">
  <path id="website" d="M20.166,36.167A15.893,15.893,0,0,0,36.02,18.121v-.012h0a15.9,15.9,0,0,0-2.969-7.39,1.427,1.427,0,0,0-.135-.179,15.94,15.94,0,0,0-25.5,0,1.407,1.407,0,0,0-.138.184,15.9,15.9,0,0,0-2.967,7.387v.012A15.894,15.894,0,0,0,20.166,36.167ZM9.152,13.12c1.415.31,2.865.536,4.321.712a34.072,34.072,0,0,0-.524,4.447c-1.619-.187-3.232-.424-4.812-.758-.251-.052-.5-.115-.749-.169A13.007,13.007,0,0,1,9.152,13.12Zm23.791,4.231c-.254.056-.5.119-.758.172-1.571.331-3.181.569-4.8.755a34.087,34.087,0,0,0-.524-4.448c1.456-.176,2.9-.4,4.321-.712h0a13.008,13.008,0,0,1,1.763,4.231Zm-.431,7.128c-.578.146-1.158.292-1.737.421-1.185.262-2.452.464-3.75.637a35,35,0,0,0,.393-4.336c1.808-.2,3.608-.461,5.359-.83.16-.033.316-.074.475-.108h0a12.972,12.972,0,0,1-.739,4.214ZM20.166,33.258c-1,0-2.255-1.612-3.162-4.444,1.032.056,2.082.094,3.162.094s2.13-.038,3.162-.094C22.422,31.646,21.167,33.258,20.166,33.258Zm4.326-14.7a59.474,59.474,0,0,1-8.651,0,30.583,30.583,0,0,1,.515-4.442c1.233.087,2.5.147,3.81.147s2.581-.059,3.81-.147h0a30.54,30.54,0,0,1,.515,4.44Zm.012,2.915a31.219,31.219,0,0,1-.457,4.377,55.43,55.43,0,0,1-7.762,0,31.219,31.219,0,0,1-.457-4.377c1.409.1,2.834.165,4.338.165s2.933-.065,4.338-.165Zm1.666-10.486A18.068,18.068,0,0,0,25,8.011a13.142,13.142,0,0,1,4.035,2.554q-1.415.256-2.865.419Zm-2.936.267a52.944,52.944,0,0,1-6.136,0c.9-2.659,2.1-4.176,3.068-4.176s2.17,1.516,3.068,4.176Zm-9.072-.266q-1.45-.164-2.865-.42a13.138,13.138,0,0,1,4.035-2.554,18.035,18.035,0,0,0-1.17,2.974ZM7.547,20.369c1.762.371,3.566.635,5.367.833a35,35,0,0,0,.393,4.335c-1.3-.173-2.564-.375-3.746-.637-.584-.131-1.163-.275-1.741-.421a12.987,12.987,0,0,1-.739-4.215c.155.033.311.074.466.105Zm2.055,7.5c1.376.282,2.824.506,4.324.678a19.167,19.167,0,0,0,1.406,3.779A13.156,13.156,0,0,1,9.6,27.866ZM25,32.323a19.167,19.167,0,0,0,1.406-3.779c1.5-.172,2.947-.4,4.324-.678A13.148,13.148,0,0,1,25,32.323Z" transform="translate(-4.166 -4.167)" fill="#1a1a1a"/>
</svg></span>
`;

export const address = html`
<span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="23.81" height="32" viewBox="0 0 25.81 32">
  <path id="loacation" d="M29.167,6a11.9,11.9,0,0,0-11.9,11.9c0,9.677,11.9,20.1,11.9,20.1s11.9-11.163,11.9-20.1A11.9,11.9,0,0,0,29.167,6Zm0,17.051A5.141,5.141,0,1,1,32.8,21.544a5.144,5.144,0,0,1-3.638,1.507Z" transform="translate(-17.262 -6)" fill="#1a1a1a"/>
</svg></span>
`;

export const provisionIcon = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <path id="generic_icon" data-name="generic icon" d="M14.5,2.5a12,12,0,1,0,12,12A12.011,12.011,0,0,0,14.5,2.5Zm2.879,5.734a1.592,1.592,0,1,1-1.592,1.592A1.585,1.585,0,0,1,17.379,8.234Zm3.209,10.56H8.411a.9.9,0,0,1-.732-1.415l4.5-6.266a.9.9,0,0,1,1.465,0l2.6,3.638a.307.307,0,0,0,.505,0l.606-.834a.9.9,0,0,1,1.465,0l2.5,3.461a.9.9,0,0,1-.732,1.415Z" transform="translate(-2.5 -2.5)" fill="#472961"/>
</svg>
`;

export const yellowTick = html`
<svg xmlns="http://www.w3.org/2000/svg" role="img" id="tick" width="18" height="18" viewBox="0 0 18 18">
  <title>A yellow tick mark, indicating the provision is available</title>
  <path id="Path_2429" data-name="Path 2429" d="M18,9A9,9,0,1,1,9,0a9,9,0,0,1,9,9" fill="#ffce58" fill-rule="evenodd"/>
  <path id="right" d="M22.9,35.243a1.1,1.1,0,0,1-.776-.322l-2.959-2.959a1.1,1.1,0,0,1,1.553-1.553L22.9,32.591l5.024-5.024a1.1,1.1,0,1,1,1.553,1.553l-5.8,5.8a1.1,1.1,0,0,1-.776.322Z" transform="translate(-15.32 -22.243)" fill="#1a1a1a"/>
</svg>
`;

export const collapseIcon = html`
<svg xmlns="http://www.w3.org/2000/svg" role="img" width="19" height="18.31" viewBox="0 0 19 18.31">
  <title>Collapse</title>
  <g id="collapse" transform="translate(-0.39 1.163)">
    <path id="Path_1751" data-name="Path 1751" d="M1.341,27.1h17.1a.95.95,0,0,0,0-1.9H1.341a.95.95,0,1,0,0,1.9Z" transform="translate(0 -20.055)" fill="#472961"/>
    <path id="Path_1752" data-name="Path 1752" d="M18.44,45.039H1.34a.95.95,0,1,0,0,1.9h17.1a.95.95,0,1,0,0-1.9Z" transform="translate(0 -36.099)" fill="#472961"/>
    <path id="Path_1754" data-name="Path 1754" d="M35.692.39h7.455a.572.572,0,0,1,.407.977L39.826,4.523a.573.573,0,0,1-.813,0L35.285,1.367A.572.572,0,0,1,35.691.39Z" transform="translate(-29.528 -1.553)" fill="#472961"/>
    <path id="Path_1755" data-name="Path 1755" d="M43.149,89.032H35.694a.572.572,0,0,1-.407-.977L39.015,84.9a.573.573,0,0,1,.813,0l3.728,3.158a.572.572,0,0,1-.407.977Z" transform="translate(-29.53 -71.885)" fill="#472961"/>
  </g>
</svg>
`;

export const expandIcon = html`
<svg xmlns="http://www.w3.org/2000/svg" role="img" width="19" height="18.309" viewBox="0 0 19 18.309">
  <title>Expand</title>
  <g id="expand" transform="translate(-0.39 1.163)">
    <path id="Path_1751" data-name="Path 1751" d="M1.341,27.1h17.1a.95.95,0,0,0,0-1.9H1.341a.95.95,0,1,0,0,1.9Z" transform="translate(0 -20.055)" fill="#472961"/>
    <path id="Path_1752" data-name="Path 1752" d="M18.44,45.039H1.34a.95.95,0,1,0,0,1.9h17.1a.95.95,0,1,0,0-1.9Z" transform="translate(0 -36.099)" fill="#472961"/>
    <path id="Path_1754" data-name="Path 1754" d="M35.692,4.694h7.455a.572.572,0,0,0,.407-.977L39.826.56a.573.573,0,0,0-.813,0L35.285,3.717a.572.572,0,0,0,.407.977Z" transform="translate(-29.528 -1.553)" fill="#472961"/>
    <path id="Path_1755" data-name="Path 1755" d="M43.149,84.727H35.694a.572.572,0,0,0-.407.977l3.728,3.157a.573.573,0,0,0,.813,0L43.556,85.7a.572.572,0,0,0-.407-.977Z" transform="translate(-29.53 -71.885)" fill="#472961"/>
  </g>
</svg>
`;

export const phone = html`
<span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="24.241" height="32" viewBox="0 0 24.241 32">
  <path id="phone" d="M42.58,33.538l-1.9-3.118v0A3.649,3.649,0,0,0,35.669,29.2l-1.567.954a1.2,1.2,0,0,1-1.46-.151,21.281,21.281,0,0,1-5.4-8.883,1.207,1.207,0,0,1,.543-1.363l1.567-.952,0,0a3.648,3.648,0,0,0,1.217-5.015l-1.9-3.118A3.651,3.651,0,0,0,23.65,9.458L20.625,11.29a3.613,3.613,0,0,0-1.754,3.1,29.492,29.492,0,0,0,4.277,15.3A29.8,29.8,0,0,0,34.718,40.5a3.753,3.753,0,0,0,1.733.429,3.631,3.631,0,0,0,1.889-.531l3.022-1.841a3.651,3.651,0,0,0,1.217-5.015Z" transform="translate(-18.871 -8.924)" fill="#472961"/>
</svg></span>
`;

export const info = html`
  <?xml version="1.0" encoding="UTF-8"?>
  <svg width="100pt" height="100pt" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <path d="m50 7.6914c-23.367 0-42.309 18.941-42.309 42.309s18.941 42.309 42.309 42.309 42.309-18.941 42.309-42.309-18.941-42.309-42.309-42.309zm-50 42.309c0-27.613 22.387-50 50-50s50 22.387 50 50-22.387 50-50 50-50-22.387-50-50zm46.152 23.078v-30.77h7.6953v30.77zm0-46.156v7.6953h7.6953v-7.6953z" fill-rule="evenodd"/>
  </svg>
`;

export const saveIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="33.656" height="33.656" viewBox="0 0 33.656 33.656">
    <g id="floppy" transform="translate(-0.391 -0.391)">
      <path id="Path_3857" data-name="Path 3857" d="M60.6,7.122h2.021a.674.674,0,0,0,.676-.676V1.066a.674.674,0,0,0-.676-.676H60.6a.674.674,0,0,0-.676.676V6.453a.669.669,0,0,0,.676.669Z" transform="translate(-39.337)" fill="#472961"/>
      <path id="Path_3858" data-name="Path 3858" d="M33.848,5.241,29.2.59a.677.677,0,0,0-.477-.2h-1.4V8.805a1.685,1.685,0,0,1-1.683,1.683H8.8A1.685,1.685,0,0,1,7.122,8.805V.391H3.756A3.362,3.362,0,0,0,.391,3.757V30.682a3.362,3.362,0,0,0,3.366,3.366H30.681a3.362,3.362,0,0,0,3.366-3.366V5.718a.677.677,0,0,0-.2-.477ZM17.219,29a6.731,6.731,0,1,1,6.731-6.731A6.732,6.732,0,0,1,17.219,29Z" transform="translate(0 0)" fill="#472961"/>
    </g>
  </svg> 
`;

export const search = html`
<svg xmlns="http://www.w3.org/2000/svg" width="24.006" height="24" viewBox="0 0 24.006 24">
  <path id="search" d="M30.207,20a10.2,10.2,0,1,0,6,18.451l5.079,5.079a1.6,1.6,0,1,0,2.264-2.262L38.47,36.188v0A10.191,10.191,0,0,0,30.207,20Zm0,17.2a7.01,7.01,0,1,1,4.947-2.053A7,7,0,0,1,30.207,37.2Z" transform="translate(-20.012 -20)" fill="#6a6a6a"/>
</svg>
`;


export const calendar = html`<svg xmlns="http://www.w3.org/2000/svg" width="32.002" height="32.654" viewBox="0 0 32.002 32.654">
  <g id="calendar" transform="translate(-3.394 -2.5)">
    <path id="Path_3857" data-name="Path 3857" d="M32.646,10.5H29.724v2.1a3.3,3.3,0,0,1-3.3,3.3H25.84a3.3,3.3,0,0,1-3.3-3.3V10.5h-6.22v2.1a3.3,3.3,0,0,1-3.3,3.3H12.4a3.3,3.3,0,0,1-3.3-3.3V10.5H6.179a2.773,2.773,0,0,0-2.785,2.785V37.62A2.773,2.773,0,0,0,6.179,40.4H32.609a2.773,2.773,0,0,0,2.785-2.785V13.285a2.722,2.722,0,0,0-2.75-2.785Zm-1.41,24.335a1.379,1.379,0,0,1-1.375,1.375H8.965A1.379,1.379,0,0,1,7.59,34.835v-13.2a1.357,1.357,0,0,1,1.375-1.375H29.828A1.379,1.379,0,0,1,31.2,21.636v13.2Z" transform="translate(0 -5.25)" fill="#472961"/>
    <path id="Path_3858" data-name="Path 3858" d="M26.515,8.962H27.1a1.613,1.613,0,0,0,1.615-1.615V4.254A1.761,1.761,0,0,0,26.961,2.5h-.309A1.761,1.761,0,0,0,24.9,4.254V7.347a1.614,1.614,0,0,0,1.617,1.615Z" transform="translate(-14.113)" fill="#472961"/>
    <path id="Path_3859" data-name="Path 3859" d="M65.515,8.962H66.1a1.613,1.613,0,0,0,1.615-1.615V4.254A1.761,1.761,0,0,0,65.961,2.5h-.309A1.761,1.761,0,0,0,63.9,4.254V7.347a1.614,1.614,0,0,0,1.617,1.615Z" transform="translate(-39.709)" fill="#472961"/>
  </g>
</svg>
`;

export const ticket = html`
<svg width="623" height="515" viewBox="0 0 623 515" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M341.571 452.525L0.000339746 315.582L32.2231 235.21C35.1221 236.791 38.1442 238.22 41.2851 239.479C84.3452 256.743 133.247 235.831 150.511 192.771C167.775 149.711 146.862 100.809 103.802 83.5449C100.662 82.2857 97.4895 81.2304 94.301 80.3711L126.523 0L468.094 136.943L341.571 452.525ZM590.17 278.539C547.11 261.276 498.207 282.188 480.944 325.248C463.68 368.308 484.592 417.21 527.652 434.474L495.649 514.298L371.273 464.433L497.796 148.851L622.173 198.716L590.17 278.539Z" fill="#472961"/>
</svg>
`;

export const email = html`
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="20.837" viewBox="0 0 32 20.837">
  <path d="M8.7,22,23,34.64,37.3,22ZM7,23.5V41.29l9.686-9.232Zm32,0-9.686,8.558L39,41.29ZM18.371,33.535,8.6,42.837H37.395l-9.767-9.3-3.884,3.442a1.116,1.116,0,0,1-1.488,0Z" transform="translate(-7 -22)" fill="#472961"/>
</svg>

`;

export const star = html`
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="16.971" viewBox="0 0 18 16.971">
  <path id="Preferred" d="M24,17l2.642,5.777L33,23.483l-4.725,4.276,1.288,6.213L24,30.837l-5.563,3.134,1.288-6.213L15,23.483l6.358-.706Z" transform="translate(-15 -17)" fill="#8141b9"/>
</svg>
`;

export const submit = html`
<svg xmlns="http://www.w3.org/2000/svg" width="18.999" height="22.799" viewBox="0 0 18.999 22.799">
  <g id="submit" transform="translate(-25 -20)">
    <path id="Path_5582" data-name="Path 5582" d="M59.059,21.617V26H64.4Z" transform="translate(-21.117 -1.003)" fill="#472961"/>
    <path id="Path_5583" data-name="Path 5583" d="M37.722,26.184a.953.953,0,0,1-.95-.95V20H25.95a.953.953,0,0,0-.95.95v20.9a.951.951,0,0,0,.95.95h17.1a.951.951,0,0,0,.95-.95V26.184Zm1.2,13.077H30.079V37.835h3.708V33.092H31.174L34.5,27.333l3.325,5.759H35.212v4.744H38.92Z" fill="#472961"/>
  </g>
</svg>

`;

export const smallX = html`
<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12.375" viewBox="0 0 12 12.375">
  <path id="not_needed" data-name="not needed" d="M22.065,18.746,17.809,14.49l4.256-4.256a.438.438,0,0,0,0-.634L20.782,8.317,16.209,12.89,11.621,8.3,10.338,9.585a.438.438,0,0,0,0,.634l4.256,4.256-4.241,4.271a.438.438,0,0,0,0,.634l1.283,1.283,4.573-4.573L20.8,20.677l1.283-1.283a.469.469,0,0,0-.015-.649Z" transform="translate(-10.203 -8.302)" fill="#8141b9"/>
</svg>
`;

export const warning = html`
<svg xmlns="http://www.w3.org/2000/svg" width="35.341" height="33.42" viewBox="0 0 35.341 33.42">
  <path id="warning" d="M22.9,6.614a3.193,3.193,0,0,0-5.476.036L2.972,33.643A3.2,3.2,0,0,0,5.7,38.5H34.638a3.2,3.2,0,0,0,2.747-4.822ZM22.567,33.2a.734.734,0,0,1-.737.737H18.5a.739.739,0,0,1-.737-.737V30.515a.739.739,0,0,1,.737-.737H21.83a.734.734,0,0,1,.737.737Zm0-6.853a.734.734,0,0,1-.737.737H18.5a.739.739,0,0,1-.737-.737V14.74A.739.739,0,0,1,18.5,14H21.83a.734.734,0,0,1,.737.737Z" transform="translate(-2.498 -5.082)" fill="#472961"/>
</svg>
`;

export const navIcons = {
   organisation: organisationIcon,
   account: accountIcon,
   lookup:lookupIcon,
   switch:switchIcon,
   arrowBack:arrowBack,
}

export const icons = {
    completedPageIcon:completedPageIcon,
    currentPageIcon:currentPageIcon,
    editIcon:editIcon,
    dots:dots,
    eyeSvg:eyeSvg,
    eyeClosedSvg:eyeClosedSvg,
    arrow:arrow,
    arrowBack:arrowBack,
    deleteIcon:deleteIcon,
    dashIcon:dashIcon,
    addIcon:addIcon,
    navIcons:navIcons,
    clock: clock,
    close: close,
    closeAlt: closeAlt,
}

export const svgToDataURL = svgStr => {
	const encoded = encodeURIComponent(svgStr)
		.replace(/'/g, '%27')
		.replace(/"/g, '%22')

	const header = 'data:image/svg+xml,'
	const dataUrl = header + encoded

	return dataUrl
}